export default __webpack_public_path__ + "./img/soundEnabled.cf407a5d310e4fb5482f7470a31e998e.png";